<template>
  <div class="home relative">
    <a href="https://wa.me/6596861969?text=I%20would%20like%20to%20enquire" target="_blank" class="bg-green-600 p-4 rounded-full fixed right-0 mr-4 bottom-0 mb-4 z-50 transition-all duration-500 ease-in">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30" fill="rgba(255,255,255,1)"><path d="M7.25361 18.4944L7.97834 18.917C9.18909 19.623 10.5651 20 12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 13.4363 4.37821 14.8128 5.08466 16.0238L5.50704 16.7478L4.85355 19.1494L7.25361 18.4944ZM2.00516 22L3.35712 17.0315C2.49494 15.5536 2.00098 13.8345 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C10.1671 22 8.44851 21.5064 6.97086 20.6447L2.00516 22ZM8.39232 7.30833C8.5262 7.29892 8.66053 7.29748 8.79459 7.30402C8.84875 7.30758 8.90265 7.31384 8.95659 7.32007C9.11585 7.33846 9.29098 7.43545 9.34986 7.56894C9.64818 8.24536 9.93764 8.92565 10.2182 9.60963C10.2801 9.76062 10.2428 9.95633 10.125 10.1457C10.0652 10.2428 9.97128 10.379 9.86248 10.5183C9.74939 10.663 9.50599 10.9291 9.50599 10.9291C9.50599 10.9291 9.40738 11.0473 9.44455 11.1944C9.45903 11.25 9.50521 11.331 9.54708 11.3991C9.57027 11.4368 9.5918 11.4705 9.60577 11.4938C9.86169 11.9211 10.2057 12.3543 10.6259 12.7616C10.7463 12.8783 10.8631 12.9974 10.9887 13.108C11.457 13.5209 11.9868 13.8583 12.559 14.1082L12.5641 14.1105C12.6486 14.1469 12.692 14.1668 12.8157 14.2193C12.8781 14.2457 12.9419 14.2685 13.0074 14.2858C13.0311 14.292 13.0554 14.2955 13.0798 14.2972C13.2415 14.3069 13.335 14.2032 13.3749 14.1555C14.0984 13.279 14.1646 13.2218 14.1696 13.2222V13.2238C14.2647 13.1236 14.4142 13.0888 14.5476 13.097C14.6085 13.1007 14.6691 13.1124 14.7245 13.1377C15.2563 13.3803 16.1258 13.7587 16.1258 13.7587L16.7073 14.0201C16.8047 14.0671 16.8936 14.1778 16.8979 14.2854C16.9005 14.3523 16.9077 14.4603 16.8838 14.6579C16.8525 14.9166 16.7738 15.2281 16.6956 15.3913C16.6406 15.5058 16.5694 15.6074 16.4866 15.6934C16.3743 15.81 16.2909 15.8808 16.1559 15.9814C16.0737 16.0426 16.0311 16.0714 16.0311 16.0714C15.8922 16.159 15.8139 16.2028 15.6484 16.2909C15.391 16.428 15.1066 16.5068 14.8153 16.5218C14.6296 16.5313 14.4444 16.5447 14.2589 16.5347C14.2507 16.5342 13.6907 16.4482 13.6907 16.4482C12.2688 16.0742 10.9538 15.3736 9.85034 14.402C9.62473 14.2034 9.4155 13.9885 9.20194 13.7759C8.31288 12.8908 7.63982 11.9364 7.23169 11.0336C7.03043 10.5884 6.90299 10.1116 6.90098 9.62098C6.89729 9.01405 7.09599 8.4232 7.46569 7.94186C7.53857 7.84697 7.60774 7.74855 7.72709 7.63586C7.85348 7.51651 7.93392 7.45244 8.02057 7.40811C8.13607 7.34902 8.26293 7.31742 8.39232 7.30833Z"></path></svg>
		</a>
    <section class="bg-top bg-cover bg-banner">
      <div class="w-full text-gray-700">
        <div class="flex items-center justify-between max-w-screen-lg p-4 pt-6 pb-2 mx-auto md:py-8">
          <h1 class="logo"><img src="images/logo.png"></h1>
          <div>
            <p class="text-xs md:text-sm">Please Contact Us At:</p>
            <div class="flex items-center">
              <svg class="md:mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M21 16.42v3.536a1 1 0 0 1-.93.998c-.437.03-.794.046-1.07.046-8.837 0-16-7.163-16-16 0-.276.015-.633.046-1.07A1 1 0 0 1 4.044 3H7.58a.5.5 0 0 1 .498.45c.023.23.044.413.064.552A13.901 13.901 0 0 0 9.35 8.003c.095.2.033.439-.147.567l-2.158 1.542a13.047 13.047 0 0 0 6.844 6.844l1.54-2.154a.462.462 0 0 1 .573-.149 13.901 13.901 0 0 0 4 1.205c.139.02.322.042.55.064a.5.5 0 0 1 .449.498z" fill="rgba(0,180,210,1)"/></svg>
              <a href="tel:+6568996609" class="text-xl font-semibold leading-snug md:text-2xl md:leading-none">6899 6609</a>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="flex items-center justify-between max-w-screen-lg px-4 pt-4 pb-8 mx-auto md:pb-16">
          <img class="hidden w-full lg:block" src="images/banner.jpg">
          <img class="w-full lg:hidden" src="images/banner-mobile.jpg">
        </div>
      </div>
    </section>
    <section>
      <div class="flex flex-wrap items-center justify-between max-w-screen-lg px-4 pt-8 pb-8 mx-auto text-center md:pt-16 md:pb-16">
        <div class="w-1/2 p-2 text-center lg:w-auto"><img class="mx-auto" src="images/brand-01.jpg"></div>
        <div class="w-1/2 p-2 text-center lg:w-auto"><img class="mx-auto" src="images/brand-02.jpg"></div>
        <div class="w-1/2 p-2 text-center lg:w-auto"><img class="mx-auto" src="images/brand-03.jpg"></div>
        <div class="w-1/2 p-2 text-center lg:w-auto"><img class="mx-auto" src="images/brand-04.jpg"></div>
      </div>
    </section>
    <section id="enquiry-form" class="bg-cover enquiry-form">
      <div class="max-w-screen-lg px-4 py-12 mx-auto md:py-24">
        <h3 class="mb-4 text-2xl font-bold text-center md:text-4xl md:mb-6">Book An Appointment</h3>
        <!-- feedback.activamedia.com.sg script begins here --><iframe ref="enquiryFormIframe" allowTransparency="true" style="min-height:300px; height:inherit; overflow:auto;" width="100%" id="contactform123" name="contactform123" marginwidth="0" marginheight="0" frameborder="0" src="https://feedback.activamedia.com.sg/my-contact-form-5684919.html?customVars123=yes&hasEmbedFormStyle=1"><p>Your browser does not support iframes. The contact form cannot be displayed. Please use another contact method (phone, fax etc)</p></iframe><!-- feedback.activamedia.com.sg script ends here -->
      </div>
    </section>
    <img class="w-full lg:hidden" src="images/bg-about.jpg">
    <section class="relative text-white bg-siteBlue">
      <div class="absolute hidden w-1/2 h-full bg-center bg-no-repeat bg-cover lg:block bg-about"></div>
      <div class="max-w-screen-lg px-4 py-12 mx-auto lg:py-24">
        <div class="lg:w-1/2 lg:ml-auto lg:pl-8">
          <h4 class="text-xl font-bold leading-none lg:text-3xl">About</h4>
          <h3 class="mb-4 text-3xl font-bold leading-none lg:text-5xl lg:mb-6">Lee Dentalcare</h3>
          <p class="leading-normal lg:text-lg">Lee Dentalcare Pte Ltd was established in the year 2001 by Dr Lee Wi-Hien. It is conveniently located at Blk 638 Bt Batok Central, just a stone’s throw away from Bt Batok MRT station and Bt Batok Bus Interchange. We aim to provide a comprehensive range of patient-oriented dental services to our valued clients.</p>
        </div>
      </div>
    </section>
    <img class="w-full lg:hidden" src="images/bg-services.jpg">
    <section class="relative text-white bg-siteBlue">
      <div class="absolute top-0 right-0 hidden w-1/2 h-full bg-center bg-no-repeat bg-cover lg:block bg-services"></div>
      <div class="max-w-screen-lg px-4 py-12 mx-auto lg:py-24">
        <div class="lg:w-1/2 lg:mr-auto lg:pr-8">
          <h3 class="mb-4 text-3xl font-bold leading-none lg:text-5xl lg:mb-6">Our services include:</h3>
          <ul class="pl-5 list-disc lg:pl-6">
            <li class="lg:text-lg">Routine General Dental Examinations</li>
            <li class="lg:text-lg">Scaling/Polishing & Fillings</li>
            <li class="lg:text-lg">Dental Implants</li>
            <li class="lg:text-lg">Digital Dental Xrays & 3D CT Scans</li>
            <li class="lg:text-lg">Root Canal Treatment</li>
            <li class="lg:text-lg">Wisdom Teeth Surgery</li>
            <li class="lg:text-lg">Dental Crowns & Bridges</li>
            <li class="lg:text-lg">Removable Dentures</li>
            <li class="lg:text-lg">Bruxism (Teeth-grinding) Splints</li>
            <li class="lg:text-lg">Gum Treatment</li>
          </ul>
        </div>
      </div>
    </section>
    <img class="w-full lg:hidden" src="images/bg-surgeon.jpg">
    <section class="relative text-white bg-siteBlue">
      <div class="absolute hidden w-1/2 h-full bg-center bg-no-repeat bg-cover lg:block bg-surgeon"></div>
      <div class="max-w-screen-lg px-4 py-12 mx-auto lg:py-24">
        <div class="lg:w-1/2 lg:ml-auto lg:pl-8">
          <h3 class="mb-4 text-3xl font-bold leading-none lg:text-5xl lg:mb-6">Our Dental Surgeon</h3>
          <p class="leading-normal lg:text-lg">Dr Lee Wi-Hien qualified with a Bachelor of Dental Surgery degree from NUS in 1990. He has garnered 30 years of experience in many aspects of dentistry. Dr Lee regularly attends international and local dentists’ seminars/courses to acquire updated knowledge and skills, especially in the field of Implant Dentistry. He is a member of ICOI ( International Congress of Oral Implantologists) and SDA (Singapore Dental Association). Together with his team of trained support staff, he delivers the most appropriate dental treatment to his patients.</p>
        </div>
      </div>
    </section>
    <section>
      <div class="max-w-screen-lg px-4 pt-8 pb-8 mx-auto text-center md:pt-16 md:pb-16">
        <h3 class="mb-4 text-2xl font-bold text-center md:text-4xl md:mb-6">Fix Your Appointment <br class="block sm:hidden">With Us Now!</h3>
        <div class="mb-4">
          <a href="#enquiry-form" class="inline-block px-6 py-4 text-lg text-white bg-siteBlue min-w-60" style="min-width: 200px;">Click Here To Book</a>
        </div>
        <div>
          <a href="https://wa.me/6596861969?text=I%20would%20like%20to%20enquire" target="_blank" class="inline-block px-6 py-4 text-lg text-white bg-green-600" style="min-width: 200px;">WhatsApp Us</a>
        </div>
      </div>
    </section>
    <section class="text-center text-white bg-siteDBlue">
      <div class="max-w-screen-lg px-4 py-8 mx-auto text-center md:py-16">
        <h4 class="text-xl font-bold leading-none lg:text-3xl">See You At</h4>
        <h3 class="mb-4 text-3xl font-bold leading-none lg:text-5xl lg:mb-6">Lee Dentalcare</h3>
        <iframe class="mb-4 lg:mb-6" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.7113440490325!2d103.74939561475404!3d1.3497093990156042!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da10409c2f05d5%3A0xc65425b75f0d38f!2sLee%20%26%20Associates%20Dental%20Care!5e0!3m2!1sen!2ssg!4v1603132971508!5m2!1sen!2ssg" width="100%" height="300" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        <p class="mb-4 leading-normal lg:text-lg lg:mb-6">
          Consultation hours:<br>
          Weekdays (Except Wed): 9:30am to 6pm<br>
          Saturday: 9:30am to 6pm<br>
          Wednesday & Sunday: 9:30am to 5pm<br>
          Contact: <a href="tel:68996609">6899 6609</a>
        </p>
        <p class="leading-normal lg:text-lg">638 Bukit Batok Central, #01-28, Singapore 650638</p>
      </div>
    </section>
  </div>
</template>

<style>
  .bg-banner {
    background-image: url('/images/bg-banner.jpg');
  }
  .logo img {
    height: 48px;
  }
  .enquiry-form {
    background-image: url('/images/bg-enquire.jpg');
  }
  .enquiry-form iframe {
    height: 520px !important;
  }
  .bg-about {
    background-image: url('/images/bg-about.jpg');
  }
  .bg-services {
    background-image: url('/images/bg-services.jpg');
  }
  .bg-surgeon {
    background-image: url('/images/bg-surgeon.jpg');
  }
  @media (min-width: 450px) {
    .enquiry-form iframe {
      height: 350px !important;
    }
  }
  @media (min-width: 768px) {
    .logo img {
      height: 60px;
    }
  }
</style>
<script>
export default {
  name: 'Home',
  mounted() {
    window.addEventListener('message', this.addToDataLayer);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.addToDataLayer);
  },
  methods:{
    addToDataLayer(event){
      if (event.source === this.$refs.enquiryFormIframe.contentWindow) {
        if (event.data && event.data.type === 'pushedData') {
          const data = event.data.data;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(data);

          // Save the updated dataLayer to sessionStorage
          sessionStorage.setItem('formData', JSON.stringify(data));

        }
      }
    }
  }

}
</script>